import Vue from 'vue';
import axios from 'axios';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

Vue.filter('toKilo', function (value) {
    return Math.round(value / 1000).toString();
});

Vue.filter('toMega', function (value) {
    return Math.round(value * 10 / 1000000) / 10;
});

var app = new Vue({
    el: '#taskekrabbePage',
    components: {
        PulseLoader
    },

    data: {
        yearsData: [],
    },

    watch: {
        yearsData: function (val) {
            // console.log(val);
        }
    },

    methods: {
        getTaskekrabbeData: function () {
            var self = this;
            axios.get('/umbraco/Surface/Statistic/GetTaskekrabbeData/')
                .then((response) => {
                    if (response.data !== 'error') {
                        self.yearsData = response.data;
                    }
                    else {
                        console.log('error');
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    },

    mounted() {
        this.getTaskekrabbeData();
    }
});


// WEBPACK FOOTER //
// ./Scripts/app/taskekrabbe/index.js